import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { EditProductComponent } from '../../edit-product.component';
import { ProductService } from 'src/app/_service/product.service';
import { AlertifyService } from 'src/app/_service/alertify.service';
import { OverlayContainer } from '@angular/cdk/overlay';

@Component({
  selector: 'app-deleteConfirmation',
  templateUrl: './deleteConfirmation.component.html',
  styleUrls: ['./deleteConfirmation.component.css']
})
export class DeleteConfirmationComponent implements OnInit {

  deleteIsModified: boolean;
  confirmModal = false;
  productRemoved: any;
  loading = false;

  constructor(@Inject(MAT_DIALOG_DATA) public passedData: any,
  public dialog: MatDialogRef<DeleteConfirmationComponent>,
  private productService: ProductService,
  private alertify: AlertifyService,
  private overlayContainer: OverlayContainer) { }

  productId = this.passedData.pData;

  ngOnInit() {}

  confirmDelete() {
    this.productService.removeProduct(this.productId).subscribe(res => {
      this.productRemoved = res.headers.get('productremoved');
      this.confirmModal = false;
      if (this.productRemoved) {
        this.alertify.message(this.productRemoved);
        this.deleteIsModified = true;
        this.loading = true;
        this.dialog.close();
      } else {
        this.loading = false;
        this.deleteIsModified = false;
        this.alertify.error('Please try again later');
      }
    });
    // this.dialog.closeAll();
  }
}
